import { Link } from "react-router-dom";
import { AuthContext, MainContext } from "../../Context";
import React, { useContext } from "react";

const Footer = () => {
  const { setting } = useContext(MainContext);
  const { token } = useContext(AuthContext);

  // ===================================================================================================

  return (
    <footer className="pb-0 w-100">
      <div className="container">
        <hr className="mt-0 position-relative" style={{ zIndex: "-1" }} />

        <div className="row pt-3 text-center">
          <div className="col-md-6 col-lg-4 mb-4">
            <img
              width={200}
              className="light-mode-item"
              src="/imgs/headerLogo.png"
              alt="logo"
            />
            <p className="mt-3">هنر رزمی کوک سول وان ایران</p>
            <p className="mt-3">هنرهای رزمی سنتی کره</p>
          </div>

          <div className="col-md-6 col-lg-3 mb-4">
            <h5 className="mb-3">لینک های مفید</h5>
            <div className="row">
              <div className="col-12">
                <ul className="nav flex-column">
                  <li className="nav-item">
                    <Link className="nav-link" to="/">
                      خانه
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link pt-0" to="/about-us">
                      درباره ما
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/contact-us">
                      تماس با ما
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/rules">
                      احکام
                    </Link>
                  </li>
                  {token ? (
                    <li className="nav-item">
                      <Link className="nav-link" to="/profile">
                        حساب کاربری
                      </Link>
                    </li>
                  ) : null}
                </ul>
              </div>
            </div>
          </div>

          <div className="col-sm-6 col-lg-2 mb-4">
            <h5 className="mb-3">شبکه های اجتماعی</h5>
            <ul className="nav flex-column">
              <li className="nav-item">
                <a
                  target="_blank"
                  className="nav-link pt-0"
                  href={setting.instagramLink}
                >
                  <i className="fab fa-instagram fa-fw me-2 text-instagram"></i>
                  Instagram
                </a>
              </li>
              <li className="nav-item">
                <a
                  target="_blank"
                  className="nav-link"
                  href={setting.telegramLink}
                >
                  <i className="fab fa-telegram fa-fw me-2 text-info"></i>
                  Telegram
                </a>
              </li>
              <li className="nav-item">
                <a
                  target="_blank"
                  className="nav-link"
                  href={setting.whatsappLink}
                >
                  <i className="fab fa-whatsapp fa-fw me-2 text-success"></i>
                  Whatsapp
                </a>
              </li>
            </ul>
          </div>
        </div>

        <hr className="mt-0 position-relative" style={{ zIndex: "-1" }} />

        <div className="col-12 pb-3 text-center">© {setting.copyright}</div>
      </div>
    </footer>
  );
};

export default Footer;
